/*
 *
 *  actions
 *
 */

import {
  //LOAD_EMPLOYEE
  LOAD_EMPLOYEE,
  LOAD_EMPLOYEE_SUCCESS,
  LOAD_EMPLOYEE_ERROR,

  LOAD_DROPDOWN,
  LOAD_DROPDOWN_SUCCESS,
  LOAD_DROPDOWN_ERROR,
} from "./constants";

export function loadRecordsCacheHit() {
  return {
    // type: LOAD_RECORDS_VALID_CACHE  organization_list
  };
}


//loadEmployee
export function loadEmployee(searchFilter) {
  return {
    type: LOAD_EMPLOYEE,
    searchFilter,
  };
}

export function loadEmployeeSuccess( employee_list, success) {
  return {
    type: LOAD_EMPLOYEE_SUCCESS,
     employee_list,
    success,
  };
}

export function loadEmployeeError(error) {
  return {
    type: LOAD_EMPLOYEE_ERROR,
    error,
  };
}

//loadDropdown
export function loadDropdown(searchFilter) {
  return {
    type: LOAD_DROPDOWN,
    searchFilter,
  };
}

export function loadDropdownSuccess(dropDownList, success) {
  return {
    type: LOAD_DROPDOWN_SUCCESS,
    dropDownList,
    success,
  };
}

export function loadDropdownError(error) {
  return {
    type: LOAD_DROPDOWN_ERROR,
    error,
  };
}

const actions = {
 
  loadEmployee,
  loadEmployeeSuccess,
  loadEmployeeError,
 
  loadRecordsCacheHit,
  
};

export default actions;
